import { moduleActionContext } from "@/store/index";
import { AxiosError, AxiosResponse } from "axios";
import { defineModule } from "direct-vuex";
import ListItemNumberModel from "../../models/listItemNumberModel";
import SupervisorEncoryListRestModel from "../../models/rest/supervisor-encory/supervisorEncoryListRestModel";
import SupervisorEncoryProjectFreightCalculationRestModel from "../../models/rest/supervisor-encory/supervisorEncoryProjectFreightCalculationRestModel";
import SupervisorEncoryRestModel from "../../models/rest/supervisor-encory/supervisorEncoryRestModel";
import SupervisorEncoryIntegrationRestModel from "../../models/rest/supervisor/supervisorEncoryIntegrationRestModel";
import { axiosInstance } from "../../plugins/axios";


export interface SupervisorEncoryModuleStateInterface {
    activeSupervisorsPlacesType: number,
    supervisorEncoryIntegrations: SupervisorEncoryIntegrationRestModel[],
    showEncoryIntegrationDialog: boolean,
    encoryIntegrationDialogTitle: string,
    encoryIntegrationDialogResolve: any;
    encoryIntegrationStates: any[];
    transportDocumentTypeList: ListItemNumberModel[];
    supervisorEncoryList: SupervisorEncoryListRestModel[];
    supervisorEncoryListLoading: false | boolean;
    supervisorEncoryListTotalCount: number;
    supervisorEncoryListPagerOptions: any;
}

const supervisorEncoryModule = defineModule({
    namespaced: true,
    state: {
        supervisorEncoryIntegrations: [] as SupervisorEncoryIntegrationRestModel[],
        showEncoryIntegrationDialog: false,
        encoryIntegrationDialogTitle: "",
        encoryIntegrationDialogResolve: null,
        encoryIntegrationStates: [
            { id: 0, state: "Not set" },
            { id: 2, state: "Scanned ad dealer (old)", disabled: true },
            { id: 52, state: "Scanned ad dealer" },
        ],
        transportDocumentTypeList: [] as ListItemNumberModel[],
        supervisorEncoryList: [] as SupervisorEncoryListRestModel[],
        supervisorEncoryListLoading: false,
        supervisorEncoryListTotalCount: 0,
        supervisorEncoryListPagerOptions: {
            page: 1,
            itemsPerPage: 200,
            sortBy: ["createdAt"],
            sortDesc: [false]
        },
    } as SupervisorEncoryModuleStateInterface,
    mutations: {
        setSupervisorEncoryIntegrations(state, value: SupervisorEncoryIntegrationRestModel[]) {
            state.supervisorEncoryIntegrations = value;
        },
        setShowEncoryIntegrationDialog(state, value: boolean) {
            state.showEncoryIntegrationDialog = value;
        },
        setEncoryIntegrationDialogTitle(state, value: string) {
            state.encoryIntegrationDialogTitle = value;
        },
        setEncoryIntegrationDialogResolve(state, value: any) {
            state.encoryIntegrationDialogResolve = value;
        },
        setTransportDocumentTypeList(state, value: ListItemNumberModel[]) {
            state.transportDocumentTypeList = value;
        },
        setSupervisorEncoryList(state, value: SupervisorEncoryListRestModel[]) {
            state.supervisorEncoryList = value;
        },
        setSupervisorEncoryListLoading(state, value: boolean) {
            state.supervisorEncoryListLoading = value;
        },
        setSupervisorEncoryListTotalCount(state, value: number) {
            state.supervisorEncoryListTotalCount = value;
            if ((state.supervisorEncoryListPagerOptions.page * state.supervisorEncoryListPagerOptions.itemsPerPage) >= (value + state.supervisorEncoryListPagerOptions.itemsPerPage)) {
                state.supervisorEncoryListPagerOptions.page = 1;
            }
        },
        setSupervisorEncoryListPagerOptions(state, value: any) {
            state.supervisorEncoryListPagerOptions = value;
        },
    },
    actions: {
        saveSupervisorEncoryDealerAddressesFile(context, payload) {
            const formData = new FormData();

            for (const index in payload) {
                formData.append("files", payload[index]);
            }

            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/supervisorEncory/upload-dealer-addresses-file", formData)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err));
            });
        },
        saveSupervisorEncoryPartsFile(context, payload) {
            const { state } = _moduleActionContext(context);
            const formData = new FormData();

            for (const index in payload) {
                formData.append("files", payload[index]);
            }

            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/supervisorEncory/upload-parts-file", formData)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err));
            });
        },
        downloadHandlingUnitsAndSendEmails(context) {
            const { state } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/supervisorEncory/download-handling-units-and-send-emails")
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err));
            });
        },
        getSupervisorEncoryIntegrations(context, payload: { supervisorId: number, forSupervisorMemento: boolean }) {
            const { commit } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/supervisorEncory/encory-integration-by-supervisor-id/" + payload.supervisorId + "/" + payload.forSupervisorMemento)
                    .then((resp: AxiosResponse) => {
                        commit.setSupervisorEncoryIntegrations(resp.data);
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
        updateSupervisorEncoryIntegrations(context) {
            const { state, rootState, rootDispatch } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/supervisorEncory/encory-integration-by-supervisor-id/update/" + rootState.supervisor.supervisor.id, state.supervisorEncoryIntegrations)
                    .then((resp: AxiosResponse) => {
                        if (resp.data == false) {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: "BŁĄD",
                                message: "Wystąpił błąd.",
                                links: [],
                                options: { buttonColor: "error", layoutColor: "error" },
                                buttonType: "ok"
                            })
                        }
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => {
                        rootDispatch.confirm.openConfirmDialog({
                            showConfirmDialog: true,
                            title: "BŁĄD",
                            message: err.message + ": " + err.response?.data,
                            links: [],
                            options: { buttonColor: "error", layoutColor: "error" },
                            buttonType: "ok"
                        })
                        reject(err);
                    });
            })
        },
        isConfirmedEncoryIntegrationDialog(context) {
            const { state, commit } = _moduleActionContext(context);
            state.encoryIntegrationDialogResolve(true);
            commit.setShowEncoryIntegrationDialog(false);
        },
        isNotConfirmedEncoryIntegrationDialog(context) {
            const { commit } = _moduleActionContext(context);
            commit.setShowEncoryIntegrationDialog(false);
        },
        openEncoryIntegrationDialog(
            context,
            payload: {
                showDialog: boolean;
                title: string;
            }
        ) {
            const { commit } = _moduleActionContext(context);
            commit.setShowEncoryIntegrationDialog(payload.showDialog);
            commit.setEncoryIntegrationDialogTitle(payload.title);
            return new Promise(resolve => {
                commit.setEncoryIntegrationDialogResolve(resolve);
            });
        },
        async getHandlingUnitDetailsByLoadCarrierNumber(context, payload: { loadCarrierNumber: string }) {
            const { commit } = _moduleActionContext(context);
            return await new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/supervisorEncory/get-handling-unit-details-by-load-carrier-number/" + payload.loadCarrierNumber)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                        return resp.data
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
        async generateSupervisorEncoryHandlingUnitComment(context, payload: { supervisorId: number }) {
            const { commit } = _moduleActionContext(context);
            return await new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/supervisorEncory/generate-supervisor-encory-handling-unit-comment/" + payload.supervisorId)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                        return resp.data
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
        loadTransportDocumentTypeList(context) {
            const { commit } = _moduleActionContext(context)
            return new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/supervisorEncory/load-transport-document-type-list")
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                        commit.setTransportDocumentTypeList(resp.data)
                    })
            })
        },
        generateAndGetSupervisorTransporDocumentFile(context, payload: { transportDocumentUnNumber: null | string, supervisorLoadingPlaceId: undefined | number, supervisorUnloadingPlaceId: undefined | number, totalNetWeightKg: undefined | number, totalQuantity: undefined | number }) {
            const { state } = _moduleActionContext(context)
            return new Promise((resolve, reject) => {
                axiosInstance
                    .get("/api/supervisorEncory/generate-and-get-supervisor-transport-document-file/" + payload.transportDocumentUnNumber + "/" + payload.supervisorLoadingPlaceId + "/" + payload.supervisorUnloadingPlaceId + "/" + payload.totalNetWeightKg + "/" + payload.totalQuantity, {
                        responseType: "blob"
                    })
                    .then((resp: AxiosResponse) => {
                        const blob = new Blob([resp.data], {
                            type: resp.headers["content-type"]
                        });
                        const contentDisposition = resp.headers["content-disposition"];
                        const filename = contentDisposition
                            .split(";")[1]
                            .split("=")[1]
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.style.display = "none";
                        document.body.appendChild(a);
                        a.download = filename;
                        a.href = url;
                        a.click();
                        window.URL.revokeObjectURL(url);

                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err));
            });
        },
        loadSupervisorEncoryList(context, payload: { page: number; itemsPerPage: number; sortBy: string; sortDesc: boolean; }) {
            const { commit } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                commit.setSupervisorEncoryListLoading(true);
                const params = {
                    page: payload.page,
                    pageSize: payload.itemsPerPage,
                    sortBy: payload.sortBy,
                    sortDesc: payload.sortDesc
                };
                axiosInstance
                    .get("/api/supervisorEncory/list", { params })
                    .then((resp: AxiosResponse) => {
                        commit.setSupervisorEncoryList(resp.data.items);
                        commit.setSupervisorEncoryListTotalCount(resp.data.totalItemsCount);
                        resolve(resp.data);
                    })
                    .catch((err: AxiosError) => reject(err))
                    .finally(() => {
                        commit.setSupervisorEncoryListLoading(false);
                    });
            });
        },
        saveSupervisorEncoryComments(context, payload: { encory: SupervisorEncoryRestModel }) {
            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/supervisorEncory/saveSupervisorEncoryHandlingUnit", payload.encory)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                    }).
                    catch((err: AxiosError) => reject(err));
            });
        },
        cancelSupervisorEncoryClick(context, payload: { supervisorEncoryHandlingUnitId: number }) {
            const { state } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/supervisorEncory/cancelSupervisorEncoryHandlingUnit/" + payload.supervisorEncoryHandlingUnitId)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                    }).
                    catch((err: AxiosError) => reject(err));
            });
        },
        calculateContractorSenderFreightBasedOnSupervisorEncoryProject(context, payload: { model: SupervisorEncoryProjectFreightCalculationRestModel }) {
            const { commit, state, rootDispatch } = _moduleActionContext(context);
            return new Promise((resolve, reject) => {
                axiosInstance
                    .post("/api/supervisorEncory/calculate-contractor-sender-freight-based-on-supervisor-encory-project", payload.model)
                    .then((resp: AxiosResponse) => {
                        resolve(resp.data);
                        if (!resp.data.isSuccess) {
                            rootDispatch.confirm.openConfirmDialog({
                                showConfirmDialog: true,
                                title: "Wyliczenia frachtu klienta dla projektu Encory",
                                message: "BŁĄD: " + resp.data.errorMessage,
                                links: [],
                                options: { buttonColor: "error", layoutColor: "error" },
                                buttonType: "ok"
                            });
                        }
                        return resp.data
                    })
                    .catch((err: AxiosError) => reject(err));
            })
        },
    }
});

export default supervisorEncoryModule;
const _moduleActionContext = (context: any) => moduleActionContext(context, supervisorEncoryModule)